import * as React from "react";
import { InlineLoading, OverlayLoading } from "../common/index";

import "./SubPageLayout.scss";

interface ISubPageLayoutProps {
    loading?: boolean;
    saving?: boolean;
}

class SubPageLayout extends React.PureComponent<ISubPageLayoutProps, any> {
    constructor(props) {
        super(props);
    }

    componentWillMount() {}

    componentWillReceiveProps(_nextProps: any) {}

    componentDidUpdate(_prevProps: any) {}

    componentWillUpdate(_nextProps: any) {}

    componentWillUnmount() {}

    render() {
        const { loading, saving } = this.props;

        return (
            <div
                className="subpagelayout-container"
                style={{
                    position: loading ? "relative" : undefined,
                    minHeight: "140px",
                }}
            >
                {loading ? (
                    <InlineLoading absoluteCenter={true} size={40} />
                ) : (
                    <div>
                        {saving ? <OverlayLoading size={40} /> : null}
                        {this.props.children}
                    </div>
                )}
            </div>
        );
    }
}

export default SubPageLayout;
